import script from "./CollapsiblePropertyOccupiers.vue?vue&type=script&setup=true&lang=js"
export * from "./CollapsiblePropertyOccupiers.vue?vue&type=script&setup=true&lang=js"

import "./CollapsiblePropertyOccupiers.vue?vue&type=style&index=0&id=3d1a525c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d1a525c"]])

export default __exports__